module.exports = __webpack_public_path__ + "dist/assets/redesign/ui/components/intro/img/vegan@2x__dc0abfc15d6d3b4058fc6de4b42abd45.png";